import './control.css';
import { useDispatch, useSelector } from 'react-redux';
import { startGame, endGame, undoMove, setAiFirst, setDepth, setIndex, setDebug } from '../store/gameSlice';
import { board_size } from '../config';
import { Button, Switch, Select } from 'antd';
import { STATUS } from '../status';
import { useCallback } from 'react';

function Control() {
  const dispatch = useDispatch();
  const { loading, winner, status, history, aiFirst, depth, index, score, path, currentDepth, debug } = useSelector((state) => state.game);
  const start = useCallback(() => {
    dispatch(startGame({board_size, aiFirst, depth}));
  }, [dispatch, board_size, aiFirst, depth]);
  const end = useCallback(() => {
    dispatch(endGame());
  }, [dispatch]);
  const undo = useCallback(() => {
    dispatch(undoMove());
  }, [dispatch]);
  const onFirstChange = useCallback((checked) => {
    dispatch(setAiFirst(checked));
  }, [dispatch]);
  const onDepthChange = useCallback((value) => {
    dispatch(setDepth(value));
  }, [dispatch]);
  const onIndexChange = useCallback((checked) => {
    dispatch(setIndex(checked));
  }, [dispatch]);
  const onDebugChange = useCallback((checked) => {
    dispatch(setDebug(checked));
  }, [dispatch]);
  
  return (
    <div className="control">
      <div className="buttons">
        <Button className="button" type="primary" onClick={start} disabled={loading || status !== STATUS.IDLE}>Start</Button>
        <Button className="button" type="primary" onClick={undo} disabled={loading || status !== STATUS.GAMING || history.length === 0}>Undo</Button>
        <Button className="button" type="primary" onClick={end} disabled={loading || status !== STATUS.GAMING}>Resign</Button>
      </div>
      <div className="setting">
        <div className="setting-row">
          <div className="setting-item">
            AI goes first: <Switch defaultChecked={aiFirst} onChange={onFirstChange} disabled={loading} />
          </div>
          <div className="setting-item difficulty">
            <span>Difficulty:</span>
            <Select
              value={String(depth)}
              style={{ width: '100%' }}
              onChange={onDepthChange}
              disabled={loading}
              options={[
                { value: '2', label: 'Easy' },
                { value: '4', label: 'Medium' },
                { value: '6', label: 'Hard' }
              ]}
            />
        </div>
          </div>
        <div className="setting-row">
          <div className="setting-item">
            Show numbers: <Switch defaultChecked={index} onChange={onIndexChange} />
          </div>
          <div className="setting-item">
            Debug mode: <Switch defaultChecked={debug} onChange={onDebugChange} disabled={loading} />
        </div>
      </div>
        </div>
      {
        debug && <div className="status">
          <div className="status-item">Score: {score}</div>
          <div className="status-item">Depth: {path?.length || 0}</div>
          <div className="status-item">AI path: {JSON.stringify(path)}</div>
          <div className="status-item">History: {JSON.stringify(history.map(h => [h.i, h.j]))}</div>
    </div>
}
    </div>
  );
}

export default Control;
